import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ProgramVm } from 'qp-ui-interface';
import { NavigationLibraryService } from '../../shared/services/navigation/navigation.service';

@Component({
  selector: 'app-epg-details',
  templateUrl: './epg-details.component.html',
  styleUrls: ['./epg-details.component.scss'],
})
export class EpgDetailsComponent implements OnInit, OnChanges {
  @Input() program: ProgramVm;
  @Output() close = new EventEmitter();
  @Output() play = new EventEmitter<ProgramVm>();
  constructor(private navService: NavigationLibraryService) {}

  ngOnInit(): void {}

  ngOnChanges(change: SimpleChanges): void {
    if (change.program) {
      const { currentValue, previousValue } = change.program;
      if (previousValue === undefined && currentValue !== undefined) {
        this.navService.focusContainer('program-panel', true);
      }
    }
  }
}
